import script from "./ListaUsuarioTeste.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaUsuarioTeste.vue?vue&type=script&setup=true&lang=js"

import "./ListaUsuarioTeste.vue?vue&type=style&index=0&id=efb8016a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb8016a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QBtn,QTable,QIcon,QTd,QImg,QPagination});
